import * as THREE from "three";
import { useThree } from "@react-three/fiber";
import { useEffect } from "react";

export function Background(props: {
  clientWidth: number;
  clientHeight: number;
}) {
  const { scene } = useThree();

  useEffect(() => {
    // Загружаем текстуру фона
    const loader = new THREE.TextureLoader();
    const bgTexture = loader.load("/s/bg.jpg", (texture) => {
      texture.colorSpace = THREE.SRGBColorSpace; // Используем правильное цветовое пространство

      const canvasAspect = props.clientWidth / props.clientHeight;
      const imageAspect = bgTexture.image
        ? bgTexture.image.width / bgTexture.image.height
        : 1;
      const aspect = imageAspect / canvasAspect;

      bgTexture.offset.x = aspect > 1 ? (1 - 1 / aspect) / 2 : 0;
      bgTexture.repeat.x = aspect > 1 ? 1 / aspect : 1;

      bgTexture.offset.y = aspect > 1 ? 0 : (1 - aspect) / 2;
      bgTexture.repeat.y = aspect > 1 ? 1 : aspect;

      // Устанавливаем текстуру как фон сцены
      scene.background = texture;
    });

    return () => {
      // Очищаем фон при размонтировании компонента
      scene.background = null; // Удаляем текстуру фона
    };
  }, [scene, props.clientWidth, props.clientHeight]); // Обновляем при изменении размеров

  return null;
}
